var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-col",
    { staticClass: "container-input" },
    [
      _c(
        "div",
        { staticClass: "upload-area", attrs: { id: _vm.id } },
        [
          _c("transition", { attrs: { name: "idle-fade" } }, [
            !_vm.loading && !_vm.success
              ? _c(
                  "div",
                  {
                    staticClass: "content content-idle",
                    class: { "error-upload": _vm.errors.length }
                  },
                  [
                    _c("div", { staticClass: "info" }, [
                      _vm._v(
                        "Arraste e solte ou clique para selecionar um arquivo."
                      )
                    ]),
                    _c("div", { staticClass: "format" }, [
                      _vm._v(
                        "Formato(s) suportado(s): " +
                          _vm._s(this.fileType.join(", "))
                      )
                    ])
                  ]
                )
              : _vm._e()
          ]),
          !_vm.loading
            ? _c("span", { staticClass: "help erro" }, [
                _vm._v(_vm._s(_vm.errors[0]))
              ])
            : _vm._e(),
          _c(
            "transition",
            { attrs: { name: "width" } },
            [
              _vm.loading
                ? _c(
                    "el-row",
                    {
                      staticClass: "content content-loader",
                      style: {
                        width:
                          (_vm.percentage < 20
                            ? 20
                            : _vm.percentage
                          ).toString() + "%"
                      }
                    },
                    [
                      _c(
                        "el-col",
                        { staticClass: "column", attrs: { span: 12 } },
                        [
                          _c("div", { staticClass: "name" }, [
                            _vm._v(_vm._s(_vm.fileName))
                          ]),
                          _vm.fileSize && !isNaN(_vm.fileSize)
                            ? _c("div", { staticClass: "size" }, [
                                _vm._v(_vm._s(_vm.fileSize) + " Kb")
                              ])
                            : _vm._e()
                        ]
                      ),
                      _c(
                        "transition",
                        { attrs: { name: "buttons-and-label-fade" } },
                        [
                          _vm.success
                            ? _c(
                                "el-col",
                                {
                                  staticClass: "column right float-left",
                                  attrs: { span: 12 }
                                },
                                [
                                  _c("div", { staticClass: "label" }, [
                                    _vm._v("Carregado com sucesso!")
                                  ])
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _c("transition", { attrs: { name: "buttons-and-label-fade" } }, [
        _vm.success
          ? _c(
              "div",
              { staticClass: "buttons" },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "excluir",
                    attrs: { name: "excluir" },
                    on: { click: _vm.excluir }
                  },
                  [
                    _c("span", { staticClass: "center" }, [
                      _c("i", { staticClass: "fas fa-times" }),
                      _c("b", [_vm._v("  Remover")])
                    ])
                  ]
                ),
                _vm.hasDownloadButton
                  ? _c(
                      "el-button",
                      {
                        staticClass: "download",
                        attrs: { name: "download" },
                        on: { click: _vm.download }
                      },
                      [
                        _c("span", { staticClass: "center" }, [
                          _c("i", { staticClass: "fas fa-download" }),
                          _c("b", [_vm._v("  Download")])
                        ])
                      ]
                    )
                  : _vm._e()
              ],
              1
            )
          : _vm._e()
      ]),
      _c("app-resumable", {
        ref: _vm.id,
        attrs: {
          target: _vm.target,
          fileType: _vm.fileType,
          idDrop: _vm.id,
          idInput: _vm.id,
          fileTypeErrorCallback: _vm.fileTypeErrorCallback,
          maxSize: _vm.maxSize || null
        },
        on: {
          onSuccess: _vm.onSuccessEvent,
          onError: _vm.onErrorEvent,
          onProgress: _vm.onProgressEvent,
          fileAdded: _vm.onFileAddedEvent
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-71a31faf", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71a31faf","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppUploadArea.vue
// module id = null
// module chunks = 